import { Box, Divider, Skeleton } from "@mui/material";
import { INTEGRATION_TILE_WIDTH } from "@pages/project-details/project-integrations/project-integrations-constants";
import { cardProperties } from "@utils/ui-utils";

/** Skeleton loading for the integration tile */
export function IntegrationTileSkeleton(): JSX.Element {
  return (
    <Box
      component="div"
      sx={{
        width: INTEGRATION_TILE_WIDTH,
        height: "200px",
        marginTop: cardProperties.marginTop,
        boxShadow: cardProperties.boxShadow,
        borderRadius: cardProperties.borderRadius,
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Skeleton variant="rectangular" sx={{ width: "30%", height: "20px" }} />
      <Skeleton variant="text" />
      <Skeleton variant="text" width="70%" />
      <Divider />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Skeleton variant="text" sx={{ width: "25%" }} />
      </Box>
    </Box>
  );
}
